/* eslint-disable import/no-extraneous-dependencies */
import { withStyles } from '@mui/styles';

import muiStyles from './styles';
import WithdrawalForm from './WithdrawalForm';

export default withStyles(muiStyles)(WithdrawalForm);